export const SPOKEN_PICK_SHAPES = {
  Choice: 'choice',
  Rating: 'rating',
  Ranking: 'ranking',
} as const;

export type SpokenPickShape =
  (typeof SPOKEN_PICK_SHAPES)[keyof typeof SPOKEN_PICK_SHAPES];

export const SPOKEN_PICK_STATUSES = {
  Idle: 'idle',
  Pending: 'pending',
  Settled: 'settled',
} as const;

export type SpokenPickStatus =
  (typeof SPOKEN_PICK_STATUSES)[keyof typeof SPOKEN_PICK_STATUSES];
